export const MODAL_ID = 'price-option-modal';
